<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {userModel} from "@/models/userModel";
import {required, sameAs,minLength,maxLength} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Thông tin ký số",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { PageHeader},

  data() {
    return {
      title: "Thông tin ký số",
      items: [
        {
          text: "Ký số",
          href: "/thong-tin-ca-nhan"
        },
        {
          text: "Thông tin ký số",
          active:true
        },
      ],
      data: [],
      modelpass:{
        password:null,
        newPass:null,
        confirmPass:null,
        userName:null,
        id:null
      },
      model: userModel.baseJson(),
      submitted: false,
      submittedPass: false,
      showNotifiModal: false,
    };
  },
  created() {
  },
  computed: {

  },
  watch:{

  },
  validations: {
    modelpass: {
      password: { required },
      newPass:{required,
        valid: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
        minLength: minLength(8),
        maxLength: maxLength(20),
      },
      confirmPass: { required, sameAsPassword: sameAs('newPass') }
    }
  },
  methods:{

  }
};
</script>

<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h5 style="text-align: center">Thông tin mã PIN</h5>
            <hr style="margin: 5px">
            <form @submit.prevent="handleSubmit" ref="formContainer">
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label class="text-left">Mã PIN hiện tại</label>
                    <span style="color: red">&nbsp;*</span>
                    <input type="hidden" v-model="model.id"/>
                    <input
                        id="lastName"
                        v-model="model.lastName"
                        type="text"
                        class="form-control"

                        :class="{
                                'is-invalid':
                                  submitted && $v.model.lastName.$error,
                              }"
                    />
                    <div
                        v-if="submitted && !$v.model.lastName.required"
                        class="invalid-feedback"
                    >
                      Họ không được trống.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label class="text-left">Mã PIN mới</label>
                    <span style="color: red">&nbsp;*</span>
                    <input type="hidden" v-model="model.id"/>
                    <input
                        id="firstName"
                        v-model="model.firstName"
                        type="text"
                        class="form-control"

                        :class="{
                                'is-invalid':
                                  submitted && $v.model.firstName.$error,
                              }"
                    />
                    <div
                        v-if="submitted && !$v.model.firstName.required"
                        class="invalid-feedback"
                    >
                      Tên không được trống.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label class="text-left">Nhập lại mã PIN mới</label>
                    <span style="color: red">&nbsp;*</span>
                    <input
                        id="phoneNumber"
                        v-model="model.phoneNumber"
                        v-mask="'##########'"
                        type="text"
                        class="form-control"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <b-button type="submit" variant="primary" class=" align-middle me-2" style="width: 100%" size="sm"
                            @click="handleSubmit"
                  >
                    Cập nhật
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h5 style="text-align: center">Ký số pháp lý VNPT</h5>
            <hr style="margin: 5px">
            <form @submit.prevent="handleSubmit" ref="formContainer">
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label class="text-left">Tài khoản ký số</label>
                    <span style="color: red">&nbsp;*</span>
                    <input type="hidden" v-model="model.id"/>
                    <input
                        id="lastName"
                        v-model="model.lastName"
                        type="text"
                        class="form-control"
                        :class="{
                                'is-invalid':
                                  submitted && $v.model.lastName.$error,
                              }"
                    />
                    <div
                        v-if="submitted && !$v.model.lastName.required"
                        class="invalid-feedback"
                    >
                      Họ không được trống.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label class="text-left">Mật khẩu ký số</label>
                    <span style="color: red">&nbsp;*</span>
                    <input type="hidden" v-model="model.id"/>
                    <input
                        id="firstName"
                        v-model="model.firstName"
                        type="text"
                        class="form-control"
                        :class="{
                                'is-invalid':
                                  submitted && $v.model.firstName.$error,
                              }"
                    />
                    <div
                        v-if="submitted && !$v.model.firstName.required"
                        class="invalid-feedback"
                    >
                      Tên không được trống.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <b-button type="submit" variant="primary" class=" align-middle me-2" style="width: 100%" size="sm"
                            @click="handleSubmit"
                  >
                    Cập nhật
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h5 style="text-align: center">Chữ ký</h5>
            <hr style="margin: 5px">
            <div class="input-group mb-3">
              <div class="custom-file">
                <input type="file" hidden id="inputGroupFile01">
                <label class="custom-file-label btn btn-info" for="inputGroupFile01">Tải hình ảnh</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
